
export default {
    name: 'Embed',
    props: {
        post: Object,
    },
    data() {
        return {
            isLarge: false,
            showCopySuccess: false,
        };
    },
    mounted() {
        if (!window.Beams) {
            let script = document.createElement('script');
            script.setAttribute('src', this.embedScriptURL);
            script.addEventListener('load', () => {
                this.loadNewEmbed();
            });
            document.head.appendChild(script);
        } else {
            this.loadNewEmbed();
        }
    },
    watch: {
        isLarge() {
            this.loadNewEmbed();
        },
    },
    methods: {
        loadNewEmbed() {
            window.Beams.renderEmbed({
                postID: this.post.id,
                mini: !this.isLarge,
                element: this.$refs['iframeDestination'],
            });
        },
        copy() {
            let copyText = document.querySelector('#embed-code');
            copyText.select();
            copyText.setSelectionRange(0, 99999); /*For mobile devices*/
            document.execCommand('copy');
            this.showCopySuccess = true;
            setTimeout(() => {
                this.showCopySuccess = false;
            }, 2000);
        },
    },
    computed: {
        embedScriptURL() {
            return `https://${this.$config.webEmbedDomain}/sdk/player.js`;
        },
        embedCode() {
            return `<script async src="${this.embedScriptURL}" data-mini="${!this.isLarge}" data-post-id="${this.post.id}"><\/script>`;
        },
    },
};
